import { XVII18nService } from '@app/i18n/services';
import { I18n } from '@app/i18n/strings-keys';
import { IModalDialogOptions } from '@app/shared/types/ui/modal-options.type';

export const getSaveBeforeProcessModal = (
  i18nService: XVII18nService,
): IModalDialogOptions => {
  return {
    text: i18nService.instant(I18n.InfoMessages.SaveTransferGroupBeforeProcess),
  };
};
